// src/components/card/CardStats.js
import React from 'react';
import { POS } from './layout';
import { fonts, place } from './ui';

const fmt = (v) => {
  if (v === null || v === undefined) return '0';
  return String(v);
};

export default function CardStats({ px, profile }) {
  const zTop = { zIndex: 2 };
  return (
    <>
      <div style={{ ...place(px, POS.point.x, POS.point.y, fonts.val), ...zTop }}>
        {fmt(profile?.POINTS)}
      </div>
      <div style={{ ...place(px, POS.pass.x, POS.pass.y, fonts.val), ...zTop }}>
        {fmt(profile?.DAY_PASS)}
      </div>
    </>
  );
}
